import { dragItemView } from './utils'

export function drag(
  absolutePoint,
  status,
  currentItemView,
  resizeOptions,
  area,
) {
  if (status !== 'drag') return false

  //drag current itemVIew
  dragItemView(currentItemView.boundary, resizeOptions, absolutePoint, area)

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/drag.js